import { graphql } from 'react-relay';

export const PendingExcessChargesQuery = graphql`
  query PendingExcessChargesQuery {
    myExcessCharges {
      computedState
    }
  }
`;
